exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ql-align-center {\n  text-align: center; }\n\n.ql-align-right {\n  text-align: right; }\n\n.ql-align-left {\n  text-align: left; }\n\n.ql-align-justify {\n  text-align: justify; }\n\n.declaration-content ol,\n.declaration-content ul {\n  list-style-position: inside; }\n", "", {"version":3,"sources":["/usr/src/app/src/components/ModalInfo/ModalInfo.scss"],"names":[],"mappings":"AAAA;EACE,mBAAmB,EAAE;;AAEvB;EACE,kBAAkB,EAAE;;AAEtB;EACE,iBAAiB,EAAE;;AAErB;EACE,oBAAoB,EAAE;;AAExB;;EAEE,4BAA4B,EAAE","file":"ModalInfo.scss","sourcesContent":[".ql-align-center {\n  text-align: center; }\n\n.ql-align-right {\n  text-align: right; }\n\n.ql-align-left {\n  text-align: left; }\n\n.ql-align-justify {\n  text-align: justify; }\n\n.declaration-content ol,\n.declaration-content ul {\n  list-style-position: inside; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"sourceMap":true,"minimize":false}!../~/postcss-loader?pack=sass!../~/sass-loader!./components/ModalInfo/ModalInfo.scss
// module id = 1084
// module chunks = 0